module.exports = __webpack_public_path__ + "media/images/auth_5-b1c331a18a95415ac4918cb713e22438.jpg";